import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
type Translations = {
    [key: string]: { [key: string]: string };
  };
  
  @Injectable({
    providedIn: 'root'
  })
  export class TranslationService {
    private languageSubject = new BehaviorSubject<string>('hr'); // Default language
  language$ = this.languageSubject.asObservable(); 
    private translations: Translations = {
      en: { 
        getStarted: 'Get Started', 
        welcome:'Welcome',
        sliderText:'All on one place',
        moreAboutTitle:'Your partner for successful work',
        moreAboutText1:'Mia Popović Consulting j.d.o.o. is an agency that understands the unique characteristics of the Dubrovnik-Neretva County and operates with in-depth knowledge of the local market and Croatias tourism sector.',
        moreAboutText2:'For more details, take a look at our services and feel free to contact us!',
        buttonMore:'See more',
        findOut:'Find out',
        whatWeDo:'What we do?',
        contactUs:'Contact us',
        weArePartners:'We are partners!',
        whatWeDoText:'Mia Popović Consulting j.d.o.o. provides professional consulting services in tourism, cleaning of apartments and tourist accommodations, as well as accommodation reservations. Our goal is to simplify the management of tourist properties and ensure an exceptional experience for guests.',
        weArePartnersText:'We are available 24/7 for all your questions and needs. You can contact us by phone or email, and for additional information and updates, visit our social media profiles. Links are available at the bottom of the page.',
        copyright:'Copyright @Mia Popovic Consulting j.d.o.o. All right reserved',
        feature1Title: 'Consulting',
        feature1Desc: 'We help you manage and improve your tourism business with advice tailored to your needs.',
        feature2Title: 'Cleaning Apartments and Tourist Accommodation',
        feature2Desc: 'We ensure impeccable cleanliness and top-notch hygiene standards for your guests’ satisfaction.',
        feature3Title: 'Accommodation Reservations',
        feature3Desc: 'We streamline and simplify the reservation process with professional guest communication.',
        postalAddress:'Postal address',
        ourEmail:'Our e-mail',
        number:'Contact number',
        mobile:'Mobile: +385 91 614 5529',
        keepInTouch:'Just keep in touch',
        contactUsNow:'Contact us now',
        contactText:'Our contact section is avalible 0-24 for all your inquiries and needs. You can contact us by phone, e-mail or social networks. We are here to answer all your questions and provide support as soon as possible.',
        quote:'We Make Ideas That Solve Problems. Sometimes We Tell Stories.',
        meetUs:'Upoznaj nas',
        ourTeam:'Naš tim',
        ceoText:'Mia Popović – Founder and driving force behind the agency Mia Popović Consulting.',
        weAreMP:'We are Mia Popovic Consulting!',
        aboutUs:'About us',
        aboutUsText:'Our company, established in 2024, is based in Klek, at the heart of the Dubrovnik-Neretva County, with a focus on providing top-quality services for tourist properties and accommodation owners in this beautiful part of Croatia. Currently, we operate within the Dubrovnik-Neretva County, with a clear vision of expanding our business across the entire country.',
        whatOurClinetsSays:'What Our Clients Says',
        reviews:'Reviews',
        reviewText:'Our clients satisfaction is our greatest motivation! Read what they have to say about their experience working with us and our services',
        home:'Home',
        features:'Services',
        about:'About',
        contact:'Contact',
        email:'E-mail:   mia.p.consulting@gmail.com',
        privateEmail:'E-mail:   popovicmia11@gmail.com',
        contactAddress:'Klek, Dubrovnik-Neretva County, Croatia',
        eventOrganisation:'Event planning',
        guide:'Let us guide you',
        eventDesc: `The event organizer is responsible for planning, coordinating, and executing various events, such as conferences, weddings, concerts, and business gatherings.<br><br>
                    <strong>Planning and Conceptualization:</strong> Understanding event objectives, developing concepts, and creating budgets.<br>
                    <strong>Venue Selection and Logistics:</strong> Booking venues, arranging transportation, accommodation, and technical support.<br>
                    <strong>Vendor Coordination:</strong> Collaborating with caterers, decorators, technical support, and performers.<br>
                    <strong>Schedule and Program Development:</strong> Planning event flow and delegating tasks.<br>
                    <strong>Marketing and Promotion:</strong> Advertising through social media and media outlets.<br>
                    <strong>Budget Management:</strong> Controlling expenses and financial planning.<br>
                    <strong>Client Communication:</strong> Understanding client needs and tailoring services accordingly.<br>
                    <strong>On-Site Supervision:</strong> Ensuring everything runs smoothly and handling unforeseen situations.<br>
                    <strong>Event Evaluation:</strong> Gathering feedback and analyzing success metrics.`,
        readMore:'Read more',
        readLess:'Read less',
        phrases: "Consulting,Cleaning,Reservations"
      },
      hr: {
        getStarted: 'Počni',
        welcome:'Dobrodošli',
        sliderText:'Sve na jednom mjestu:',
        moreAboutTitle:'Vaš partner za uspješan rad',
        moreAboutText1:'Mia Popović Consulting j.d.o.o. je agencija koja razumije specifičnosti područja Dubrovačko - Neretvanske županije te djeluje s dubokim poznavanjem lokalnog tržišta i hrvatskog turističkog sektora.',
        moreAboutText2:'Za više detalja pogledajte naše usluge i kontaktirajte nas!',
        buttonMore:'Vidi više',
        findOut:'Saznaj',
        whatWeDo:'Što radimo?',
        contactUs:'Kontaktiraj nas',
        weArePartners:'Partneri smo!',
        whatWeDoText:'Mia Popović Consulting j.d.o.o. pruža profesionalne usluge konzaltinga u turizmu, organizaciju događaja, čišćenja apartmana i turističkog smještaja te rezervacija smještaja. Naš cilj je olakšati upravljanje turističkim objektima i osigurati vrhunsko iskustvo gostima.',
        weArePartnersText:'Dostupni smo 0-24 za sva vaša pitanja i potrebe. Možete nas kontaktirati putem telefona ili e-maila, a za dodatne informacije i novosti posjetite naše profile na društvenim mrežama. Linkovi su dostupni na dnu stranice.',
        copyright:'Autorska prava @Mia Popović Consulting j.d.o.o. Sva prava zadržana',
        feature1Title: 'Konzalting',
        feature1Desc: 'Pomažemo Vam u vođenju i unapređenju turističkog poslovanja kroz savjete prilagođene Vašim potrebama.',
        feature2Title: 'Čišćenje apartmana i turističkog smještaja',
        feature2Desc: 'Osiguravamo besprijekornu čistoću i vrhunske higijenske standarde za zadovoljstvo Vaših gostiju.',
        feature3Title: 'Rezervacije smještaja',
        feature3Desc: 'Ubrzavamo i pojednostavljujemo proces upravljanja rezervacijama, uz profesionalnu komunikaciju s gostima.',
        postalAddress:'Poštanska adresa',
        ourEmail:'Naš e-mail',
        number:'Kontakt broj',
        mobile:'Mobitel: +385 91 614 5529',
        keepInTouch:'Samo ostanite u kontaktu',
        contactUsNow:'Kontaktirajte nas sada',
        contactText:'Naša kontakt sekcija dostupna je 0-24 za sve Vaše upite i potrebe. Možete nas kontaktirati putem telefona, e-maila ili društvenih mreža. Tu smo da odgovorimo na sva Vaša pitanja i pružimo podršku u najkraćem mogućem roku.',
        quote:'Mi stvaramo ideje koje rješavaju probleme. Ponekad pričamo priče.',
        meetUs:'Upoznaj nas',
        ourTeam:'Naš tim',
        ceoText:'Mia Popović – Osnivačica i pokretačka snaga iza agencije Mia Popović Consulting.',
        weAreMP:'Mi smo Mia Popovic Consulting',
        aboutUs:'O nama',
        aboutUsText:'Naša firma, osnovana 2024. godine, smještena je u Kleku, u srcu Dubrovačko-neretvanske županije, s fokusom na pružanje vrhunskih usluga za turističke objekte i vlasnike smještaja u ovom predivnom dijelu Hrvatske. Trenutno pružamo usluge na području Dubrovačko-neretvanske županije, s jasnom vizijom širenja poslovanja na cijelu Hrvatsku.',
        whatOurClinetsSays:'Što naši klijenti kažu',
        reviews:'Recenzije',
        reviewText:'Zadovoljstvo naših klijenata naša je najveća motivacija! Pročitajte što kažu o iskustvu suradnje s nama i našim uslugama',
        home:'Početna',
        features:'Usluge',
        about:'O nama',
        contact:'Kontakt',
        email:'E-mail:   mia.p.consulting@gmail.com',
        privateEmail:'E-mail:   popovicmia11@gmail.com',
        contactAddress:'Klek, Dubrovačko - Neretvanska županija, Hrvatska',
        eventOrganisation:'Organizacija događaja',
        guide:'Dozvolite da Vas usmjerimo',
        eventDesc: `Organizator događaja odgovoran je za planiranje, koordinaciju organizaciju i realizaciju različitih događaja, poput konferencija, vjenčanja, koncerata i poslovnih skupova.<br><br>
                    <strong>Planiranje i konceptualizacija:</strong> Razumijevanje ciljeva događaja, izrada koncepta i budžeta.<br>
                    <strong>Odabir lokacije i organizacija logistike:</strong> Rezervacija prostora, organizacija prijevoza, smještaja i tehničke podrške.<br>
                    <strong>Koordinacija dobavljača:</strong> Suradnja s cateringom, dekoraterima, tehničkom podrškom i izvođačima.<br>
                    <strong>Kreiranje rasporeda i programa događaja:</strong> Planiranje tijeka događaja i delegiranje zadataka.<br>
                    <strong>Promocija i oglašavanje:</strong> Oglašavanje putem društvenih mreža i medija.<br>
                    <strong>Upravljanje budžetom:</strong> Kontrola troškova i financijsko planiranje.<br>
                    <strong>Komunikacija s klijentima:</strong> Razumijevanje njihovih potreba i prilagodba ponude.<br>
                    <strong>Nadzor tijekom događaja:</strong> Osiguravanje da sve teče prema planu i rješavanje nepredviđenih situacija.<br>
                    <strong>Evaluacija događaja:</strong> Prikupljanje povratnih informacija i analiza uspješnosti.`,
        readMore:'Procitaj vise',
        readLess:'Procitaj manje',
        phrases: "Savjetovanje,Čišćenje,Rezervacije"
      },
      
    };
  
    setLanguage(lang: string): void {
      this.languageSubject.next(lang); // Notify subscribers
    }
  
    translate(key: string): string {
      const currentLang = this.languageSubject.value;
      return this.translations[currentLang]?.[key] || key;
    }
  }
  